<script lang="ts" setup>

import _ from 'lodash'
import { computed, onMounted, ref, watch } from 'vue'

const props = withDefaults(defineProps<{
  isOpen: boolean
  lineClamp?: number
}>(), {
  lineClamp: 3,
})

// todo upgrade vue3.3 and use https://vuejs.org/guide/typescript/composition-api#typing-component-emits
const emit = defineEmits<{
  (e: 'display-toggle-button', displayToggle: boolean): void
}>()

const container = ref(null)

const lineClampStyle = computed(() => {
  if (!props.isOpen) {
    return {
      '-webkit-line-clamp': props.lineClamp,
      'line-clamp': props.lineClamp,
    }
  }
  return {}
})

onMounted(() => {
  updateWrapperHeight()
  window.addEventListener('resize', _.throttle(updateWrapperHeight, 500, { leading: false, maxWait: 500, trailing: true }))
})

watch(() => props.isOpen, _.throttle(function() {
  updateWrapperHeight()
}, 500, { leading: false, maxWait: 500, trailing: true }))

function updateWrapperHeight() {
  emit('display-toggle-button', props.isOpen || container.value.scrollHeight > container.value.clientHeight ? true : false)
}
</script>

<template>
  <div
    ref="container"
    class="line-clamp-container"
    :style="lineClampStyle"
  >
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.line-clamp-container {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #ffffff; // used to hide the ellipsis
}
</style>
